import(/* webpackMode: "eager" */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/app/error.tsx");
